
const entrypoints = {
  loc: {
    controllerURL: 'https://555iwvmk67.execute-api.us-east-1.amazonaws.com/dev/public'
  },
  dev: {
    controllerURL: 'https://555iwvmk67.execute-api.us-east-1.amazonaws.com/dev/public'
  },
  stg: {
    controllerURL: 'https://4dohpcaeb0.execute-api.us-east-1.amazonaws.com/stg/public'
  },
  prd: {
    controllerURL: 'https://ylv971g9a1.execute-api.us-east-1.amazonaws.com/prd/public'
  }
}

module.exports.entrypoints = entrypoints
